'use client';

import { fontInter } from '@m/assets/fonts/inter/FontInterLoader';
import { fontPlayfairDisplay } from '@m/assets/fonts/playfair-display/FontPlayfairDisplayLoader';
import { fontTTHoves } from '@m/assets/fonts/tt-hoves/FontTTHovesLoader';

/**
 * Loads next/font faces and declares their CSS variables on `:root`.
 *
 * Chakra body/heading tokens reference `--font-tt-hoves`, `--font-inter`, and
 * `--font-playfair`. Defining them on `:root` (instead of a layout `className`)
 * keeps font setup in the Next.js provider and works for portaled UI.
 */
export function NextFonts() {
  return (
    <style
      dangerouslySetInnerHTML={{
        __html: `:root {
  --font-tt-hoves: ${fontTTHoves.style.fontFamily};
  --font-inter: ${fontInter.style.fontFamily};
  --font-playfair: ${fontPlayfairDisplay.style.fontFamily};
}`,
      }}
    />
  );
}
